import { ColorModeNameEnum, COLOR_MODE_KEY } from "../../constants/Enums/UiEnum"
import { LocalStorageService } from '../LocalStorageService'
import store from '../..'
/**
 * @namespace CustomisationHelper 
 */
const customVarNames = [
    '--brand-color-1',
    '--brand-color-2',
    '--brand-color-3',
    '--brand-gradient-1',
    '--brand-gradient-2',
    '--brand-color-text',
    '--background-color-1',
    '--background-color-2',
    '--background-color-3',
    '--background-color-4',
    '--background-color-5',
    '--background-color-6',
    '--text-color-1',
    '--text-color-2',
    '--text-color-3',
    '--text-color-4',
    '--font-family-1',
    '--btn-radius-top-left',
    '--btn-radius-top-right',
    '--btn-radius-bottom-left',
    '--btn-radius-bottom-right',
    '--input-radius-top-left',
    '--input-radius-top-right',
    '--input-radius-bottom-left',
    '--input-radius-bottom-right',
    '--odd-radius-top-left',
    '--odd-radius-top-right',
    '--odd-radius-bottom-left',
    '--odd-radius-bottom-right',
    '--white-color',
    '--black-color',
    '--error-color',
    '--success-color',
    '--info-color'
];

export const CustomisationHelper = {
    /** Get css custom variables with custom values
     */
    getCustomCssVars(withPrefix = true) {
        //read css styles from root
        const colorMode = document.documentElement.dataset.theme;
        // delete sport inline styles on HTML element
        customVarNames.forEach(function (varName) {
            document.documentElement.style.removeProperty(varName);
        })
        let computedStyle = colorMode ? getComputedStyle(document.querySelector(`[data-theme="${colorMode}"]`)) : getComputedStyle(document.documentElement);
        const cssVars = {}

        customVarNames.forEach(function (varName) {

            const value = computedStyle.getPropertyValue(varName).trim();

            if (!withPrefix && varName?.startsWith('--')) {
                varName = varName.substring(2);
            }

            cssVars[varName] = value;
        });
        return cssVars;
    },

    /** Get popup css custom variables with custom values
    */
    getPopupCustomCssVars(variables, withPrefix = true) {
        let computedStyle = getComputedStyle(document.body);
        const cssVars = {}
        variables.forEach(function (varName) {

            const value = computedStyle.getPropertyValue(varName).trim();

            if (!withPrefix && varName?.startsWith('--')) {
                varName = varName.substring(2);
            }

            cssVars[varName] = value;
        });
        return cssVars;
    },
    /** Map website styles with virtual sport styles */
    getVirtualSportStyles() {
        //read css styles from root
        const styles = CustomisationHelper.getCustomCssVars();

        const vsStyles = {
            "--brand-color-1": styles['--brand-color-1'],
            "--vs--bg-color": styles['--background-color-1'],
            "--vs--bg-color-base": styles['--background-color-2'],
            "--vs--bg-color-heading": styles['--background-color-3'],
            "--vs--bg-color-element": styles['--background-color-3'],
            "--vs--bg-color-element-default": styles['--background-color-4'],
            "--vs--bg-color-element-hover": styles['--background-color-5'],
            "--vs--bg-color-expanded": styles['--background-color-5'],
            "--vs--text-color-1": styles['--text-color-1'],
            "--vs--text-color-2": styles['--text-color-2'],
            "--vs--text-color-3": styles['--text-color-3'],
            "--vs--icon-color": styles['--text-color-1'],
            "--vs--icon-color-default": styles['--text-color-2'],
            "--vs--icon-color-hover": styles['--text-color-3'],
            "--font-family": styles['--font-family-1'],
            "--border-radius": styles['--border-radius-top-left'],

        };

        // const vsStyles = [
        //     { key: "--brand-color-1", value: styles['--brand-color-1'] },
        //     { key: "--vs--bg-color", value: styles['--background-color-1'] },
        //     { key: "--vs--bg-color-base", value: styles['--background-color-2'] },
        //     { key: "--vs--bg-color-heading", value: styles['--background-color-3'] },
        //     { key: "--vs--bg-color-element", value: styles['--background-color-3'] },
        //     { key: "--vs--bg-color-element-default", value: styles['--background-color-4'] },
        //     { key: "--vs--bg-color-element-hover", value: styles['--background-color-2']  },
        //     { key: "--vs--bg-color-expanded", value: styles['--background-color-5'] },
        //     { key: "--vs--text-color-1", value: styles['--text-color-1'] },
        //     { key: "--vs--text-color-2", value: styles['--text-color-2'] },
        //     { key: "--vs--text-color-3", value: styles['--text-color-3'] },
        //     { key: "--vs--icon-color", value: styles['--text-color-1']  },
        //     { key: "--vs--icon-color-default", value: styles['--text-color-2'] },
        //     { key: "--vs--icon-color-hover", value: styles['--text-color-3'] },
        //     { key: "--font-family", value: styles['--font-family-1']  },
        //     { key: "--border-radius", value: styles['--border-radius-top-left'] }
        // ];

        return vsStyles;
    },

    /** Map website styles with cashier iframe */
    getCashierIframeColors() {
        //read css styles from root
        const styles = CustomisationHelper.getPopupCustomCssVars(['--modal-bg-color-3', '--modal-bg-color-1', '--brand-color-1', '--modal-bg-color-1', '--modal-text-color-3', '--error-color']);
        const theme = {
            cashierColors: {
                mainBackgroundColor: styles['--modal-bg-color-3'],
                psItemBackgroundColor: styles['--modal-bg-color-1'],
                colorNeutralMinimum: '#fff',
                brandColor: styles['--brand-color-1'],
                inputColor: styles['--modal-bg-color-1'],
                labelColor: styles['--modal-text-color-3'],
                errorColor: styles['--error-color']
            }
        }
        return theme;
    },

    /** Map website styles with betgames styles */
    getBetGamesStyles() {
        //read css styles from root
        const styles = CustomisationHelper.getCustomCssVars();

        const betGamesStyles = {
            '--primary': styles['--brand-color-1'],
            '--secondary': styles['--brand-color-2'],
            '--text-on-primary': styles['--background-color-1'],
            '--text-on-secondary': styles['--background-color-1'],
            '--text-alternate': styles['--text-color-2'],
            '--body': styles['--background-color-2'],
            '--body-text': styles['--text-color-2'],

            '--button': styles['--background-color-3'],
            '--button-text': styles['--text-color-2'],
            '--button-hover': 'var(--secondary)',
            '--button-hover-text': styles['--background-color-1'],

            '--odd-item': styles['--background-color-5'],
            '--odd-item-active': 'var(--secondary)',
            '--odd-item-hover': 'var(--secondary)',
            '--odd-item-disabled': styles['--background-color-4'],
            '--odd-item-hover-text': 'var(--button-hover-text)',

            '--dialog': 'var(--odd-item)',
            '--dialog-header': styles['--background-color-3'],
            '--dialog-text': 'var(--odd-item-text)',

            // '--border-radius-xs': '',
            // '--border-radius-sm': '',
            // '--panel-border-radius': '',

            '--border': 'rgba(255, 255, 255, 0.1)',

            '--place-bet-button-hover': 'var(--secondary)',
            '--reports': styles['--background-color-3'],
            '--reports-hover': styles['--background-color-4'],
            '--reports-text': styles['--text-color-4'],
            '--reports-hover-text': 'var(--reports-text)',
            '--navigation': styles['--background-color-1'],
            '--navigation-text': styles['--text-color-4'],
            '--input-border': styles['--background-color-5'],
        };

        return betGamesStyles;
    },
    /** Initial theme */
    isThemeEnabled() {
        const { uiSettingMode } = store.getState().settings;
        return !!uiSettingMode;

    },
    /** Initial theme */
    getSelectedColorMode() {
        const storeData = LocalStorageService.get(COLOR_MODE_KEY);
        const { uiSettingMode } = store.getState().settings;
        let currentColorMode = storeData?.mode || uiSettingMode;
        return +currentColorMode;

    },
    /** Initial theme name*/
    getSelectedColorModeName() {
        const currentColorMode = CustomisationHelper.getSelectedColorMode();
        const colorMode = currentColorMode ? ColorModeNameEnum[currentColorMode] : null;
        return colorMode;
    },
    /** Check uf selected color mode inverted*/
    IsInvertedColorModeSelected() {
        const storeColorModeData = LocalStorageService.get(COLOR_MODE_KEY)
        const isInvert = storeColorModeData?.defaultValue && storeColorModeData?.mode !== storeColorModeData?.defaultValue

        return isInvert
    },

    /** Update sport mobile custom css variables */
    updateSportMobileStyles(styles = null) {

        if (window.digiAppDispatcher) {
            // const updatableStyle = {}
            // if (styles) {
            //     updatableStyle = styles;
            // } else {
            //     updatableStyle = this.getCustomCssVars();
            // }
            window.digiAppDispatcher('UPDATE_CSS_VARIABLES', styles)
        }
    }
}


